import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { howWorks } from '../../constants-monisfer-infos';

@Component({
  selector: 'app-how-it-work',
  imports: [MatProgressSpinnerModule],
  templateUrl: './how-it-work.component.html',
  styleUrl: './how-it-work.component.scss',
})
export class HowItWorkComponent {
  readonly howWorks = howWorks;
}
